export default "__VITE_ASSET__7U_1SR$M__"